module.exports = __webpack_public_path__ + "img/czsc_18.34b4bc8d.png";